import axios from "axios";
import Vue from "vue";


const state = {
  /**
   * Aktuálně vybraná skupina
   */
  groupset: null
};

const getters = {
  getGroupset: (state) => {
    return state.groupset;
  },

  getGroupsetId: (state) => {
    return (state.groupset !== null) ? state.groupset.groupSetId : null;
  }
};

const actions = {
  fetchGroupsets({ dispatch }) {
    let tid;
    return dispatch("progress/add", "Fetch record", { root: true })
      .then(id => {
        tid = id;
        return axios.get("/v1/{#company#}/groupset");
      }).catch((error) => {
        console.log("Groupsets fetch error", error);
        if (error.response)
          return { error: true, message: error.response.data.error };
        else
          return { error: true };
      }).finally(() => dispatch("progress/remove", tid, { root: true }));
  },

  setGroupset({ commit, dispatch }, groupset) {
    let tid;

    let g_id;
    let b_fetch;

    if (groupset === null) {
      g_id = null;
      b_fetch = true;
    } else if (Number.isInteger(groupset)) {
      g_id = groupset;
      b_fetch = true;
    } else {
      g_id = groupset.id;
      b_fetch = groupset.fetch;
    }

    if (g_id === null) {
      commit("setGroupset", { groupset: null });
      if (b_fetch)
        this.dispatch("online/fetchVehicles");
      return;
    }

    return dispatch("progress/add", "Fetch record", { root: true })
      .then(id => {
        tid = id;
        return axios.get("/v1/{#company#}/groupset/" + g_id);
      }).then(response => {
        commit("setGroupset", { groupset: response.data });
        if (b_fetch)
          this.dispatch("online/fetchVehicles");
      }).catch((error) => {
        console.log("Groupsets fetch error", error);
        commit("setGroupset", { groupset: null });
        if (b_fetch)
          this.dispatch("online/fetchVehicles");
      }).finally(() => dispatch("progress/remove", tid, { root: true }));
  }
};

const mutations = {
  setGroupset(state, params) {
    Vue.set(state, "groupset", params.groupset);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};